// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"AuthProfileTypeIcon_iconContainer__vwkIE"};